import IconBase from "./IconBase";

// A toggle, shown switched on. The knob is solid: a stroked circle inside the
// pill leaves under a pixel of clearance at 18px and fills in to a blob.
const BooleanIcon = (props) => (
    <IconBase {...props}>
        <rect x="3" y="6.25" width="18" height="11.5" rx="5.75" />
        <circle cx="15.75" cy="12" r="2.6" fill="currentColor" stroke="none" />
    </IconBase>
);

export default BooleanIcon;
